import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Sidebar from "./Sidebar";

export default function Anonymouslayout() {
  const [showmenu, setShowmenu] = useState(false);
  return (

    <div className="page-wrapper">
      <NavBar setShowmenu={setShowmenu} showmenu={showmenu} />
      <main id="page-main">
        <div className="page-inner-wrapper d-flex">
          <Sidebar setShowmenu={setShowmenu} showmenu={showmenu} />
          <div className="page-inner-content w-100 bg-light">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
